<nav class="navbar" *ngIf="authentication.isLogin()">
    <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
      <i class="feather icon-menu"></i>
    </a>
    <div class="navbar-content" *ngIf="authentication.isLogin()">

      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" (click)="themeService.toggle()" title="Cambiar tema" style="cursor: pointer;">
            <i class="feather" [class.icon-moon]="(themeService.theme$ | async) === 'light'" [class.icon-sun]="(themeService.theme$ | async) === 'dark'"></i>
          </a>
        </li>
        <li class="nav-item">
          <app-notification-bell></app-notification-bell>
        </li>
        <li class="nav-item nav-profile" ngbDropdown *ngIf="getUserDataAuth()">
          <a class="nav-link" ngbDropdownToggle id="profileDropdown">
            <ng-container *ngIf="hasGoogleAvatar(); else initialsSmall">
              <img class="wd-30 ht-30 rounded-circle profile-avatar-image"
                   [src]="getUserDataAuth().urlImg"
                   alt="profile">
            </ng-container>
            <ng-template #initialsSmall>
              <div class="avatar-initials wd-30 ht-30 rounded-circle d-flex align-items-center justify-content-center"
                   [style.background-color]="getAvatarColor()">
                <span class="text-white fw-bold" style="font-size: 12px;">
                  {{ getUserInitials() }}
                </span>
              </div>
            </ng-template>
          </a>
          <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
            <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
              <div class="mb-3">
                <div class="profile-avatar-upload" (click)="openAvatarFilePicker()" title="Cambiar foto de perfil">
                  <ng-container *ngIf="hasGoogleAvatar(); else initialsLarge">
                    <img class="wd-80 ht-80 rounded-circle profile-avatar-image"
                         [src]="getUserDataAuth().urlImg"
                         alt="profile">
                  </ng-container>
                  <ng-template #initialsLarge>
                    <div class="avatar-initials wd-80 ht-80 rounded-circle d-flex align-items-center justify-content-center"
                         [style.background-color]="getAvatarColor()">
                      <span class="text-white fw-bold" style="font-size: 32px;">
                        {{ getUserInitials() }}
                      </span>
                    </div>
                  </ng-template>
                  <div class="profile-avatar-overlay">
                    <i class="feather icon-edit-2"></i>
                  </div>
                </div>
                <input
                  #profileAvatarInput
                  id="profileAvatarInput"
                  type="file"
                  class="d-none"
                  accept="image/*"
                  (change)="onProfileAvatarSelected($event)"
                />
              </div>
              <div class="text-center">
                <p class="tx-16 fw-bolder">{{getUserDataAuth().correo}}</p>
                <p class="tx-12 text-muted">{{getUserRole() | titlecase}}</p>
              </div>
            </div>
            <ul class="list-unstyled p-1">
              <li class="dropdown-item py-2">
                <button type="button" (click)="onLogout($event)" class="d-flex btn text-body ms-0">
                  <i class="feather icon-log-out me-2 icon-md"></i>
                  <span>Salir</span>
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
